import React, { useState } from "react";
import { Nav, NavItem, NavLink, TabPane, TabContent } from "reactstrap";
import classnames from 'classnames';
import { APPROVED, PENDING, REJECTED, WAITING_FOR_APPROVAL } from "../../config/constants";
import { useSelector } from "react-redux";
import { MESSAGES } from "../../config/message";
import RfqListing from "../rfq/RfqListing";

const RfqApprovalTabs = (props) => {

    const [activeTab, setActiveTab] = useState('1')
    const dashboardTabLock = useSelector(state => state.comman.dashboardTabLock)

    /**
    * @method toggle
    * @description toggling the tabs
    */
    const toggle = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab)
        }
    }

    return (
        <>
            <Nav tabs className="subtabs mt-0 p-relative">
                {dashboardTabLock && <div title={MESSAGES.LOADING_MESSAGE} className="disabled-overflow min-width"></div>}
                <NavItem>
                    <NavLink id={`dashboard_rfq_Pending_For_Approval`} className={classnames({ active: activeTab === '1' })} onClick={() => { toggle('1'); }}>
                        Pending For Approval
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink id={`dashboard_rfq_Awaiting_Approval`} className={classnames({ active: activeTab === '2' })} onClick={() => { toggle('2'); }}>
                        Awaiting Approval
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink id={`dashboard_rfq_Rejected`} className={classnames({ active: activeTab === '3' })} onClick={() => { toggle('3'); }}>
                        Rejected
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink id={`dashboard_rfq_Approved`} className={classnames({ active: activeTab === '4' })} onClick={() => { toggle('4'); }}>
                        Approved
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
                {activeTab === '1' &&
                    <TabPane tabId="1">
                        <RfqListing isDashboard={true} isApprovalTab={true} isPageNoChange={props.isPageNoChange} status={PENDING} />
                    </TabPane>}
                {activeTab === '2' &&
                    <TabPane tabId="2">
                        <RfqListing isDashboard={true} isApprovalTab={true} isPageNoChange={props.isPageNoChange} status={WAITING_FOR_APPROVAL} />
                    </TabPane>}
                {activeTab === '3' &&
                    <TabPane tabId="3">
                        <RfqListing isDashboard={true} isApprovalTab={true} isPageNoChange={props.isPageNoChange} status={REJECTED} />
                    </TabPane>}
                {activeTab === '4' &&
                    <TabPane tabId="4">
                        <RfqListing isDashboard={true} isApprovalTab={true} isPageNoChange={props.isPageNoChange} status={APPROVED} />
                    </TabPane>}
            </TabContent>
        </>
    )
}

export default RfqApprovalTabs;
